import PaletteEditorDialogMixin from "@/components/palette/settings/PaletteEditorDialogMixin";
import CodeBlock from "@/components/CodeBlock.vue";
import PageList from "@/components/palette/settings/page/PageList.vue";
export default {
    name: "PalettePageEditor",
    components: { PageList, CodeBlock },
    mixins: [PaletteEditorDialogMixin],
    inject: ["editorState"],
};
